// Dependencies
import React from 'react';
import { ThemeContext } from '../../components/theme/Theme.jsx';
import radium from 'radium';

import history from '../../lib/history';

import ZigZagBox from '../../components/zig-zag-box/ZigZagBox.jsx';
import Button from '../../components/button/Button.tsx';
import ButtonEventsOverview from '../../components/button-events-overview/ButtonEventsOverview.jsx';

function SaleNotPossibleInfo(props) {
	const context = React.useContext(ThemeContext);
	const showShoppingcartBtn = context.themeManager.valueOrDefault(
		'shopping-cart', 'disable-multi-events-booking', null, 'false') === 'false';

	const style = {
		textContainerSaleNotPossible: {
			color: context.themeManager.value('sale-not-possible-text',
			'color', 'fg-color-text-highlight'),
			fontSize: '1.25em',
			fontWeight: '500',
			margin: '0 0 0.5em',
			wordBreak: 'keep-all',
		},
		textContainerStartOfSale: {
			color: context.themeManager.value('start-of-sale-text',
			'color', 'fg-color-text-highlight'),
			fontSize: '1.25em',
			fontWeight: '500',
			margin: '0 0 0.5em',
			wordBreak: 'keep-all',
		},
		buttonContainer: {
			marginTop: '3em',
		},
	};

	let saleNotPossibleText = null;
	let startOfSaleText = null;

	function initSaleNotPossibleTexts(lifeCyclePhase, categoriesAreAvailable, ticketsAreAvailable, startOfSale, shipmentPaymentPossible) {
		if ((lifeCyclePhase === 'ON_EDIT' || lifeCyclePhase === 'SUSPENDED') && startOfSale) {
			saleNotPossibleText = context.themeManager.getThemeTextOrHardcodedDefault('saleNotPossibleInfoNotOnSale');
			startOfSaleText = startOfSale;
			return;
		}
		if (lifeCyclePhase !== 'ON_SALE') {
			saleNotPossibleText = context.themeManager.getThemeTextOrHardcodedDefault('saleNotPossibleInfoNotOnSale');
			return;
		}
		if (!categoriesAreAvailable) {
			saleNotPossibleText = context.themeManager.getThemeTextOrHardcodedDefault('saleNotPossibleInfoCategoriesAreNotAvailable');
			return;
		}
		if (!ticketsAreAvailable) {
			saleNotPossibleText = context.themeManager.getThemeTextOrHardcodedDefault('saleNotPossibleInfoTicketsNotAvailable');
			return;
		}
		if (!shipmentPaymentPossible) {
			saleNotPossibleText = context.themeManager.getThemeTextOrHardcodedDefault('saleNotPossibleInfoShipmentPaymentNotPossible');
			return;
		}
		saleNotPossibleText = context.themeManager.getThemeTextOrHardcodedDefault('saleNotPossibleInfoDefault');
	}

	initSaleNotPossibleTexts(
		props.lifeCyclePhase,
		props.categoriesAreAvailable,
		props.ticketsAreAvailable,
		props.startOfSale,
		props.shipmentPaymentPossible
	);

	return (
		<div>
			<ZigZagBox>
				{
					<div style={style.textContainerSaleNotPossible}>
						{saleNotPossibleText}
					</div>
				}
				{
					startOfSaleText &&
					<div style={style.textContainerStartOfSale}>
						{startOfSaleText}
					</div>
				}
			</ZigZagBox>
			{showShoppingcartBtn &&
				<Button
					name={'addToShoppingCart'}
					buttonText={'Zum Warenkorb'}
					btnStyle={'highlight'}
					buttonContainerStyle={style.buttonContainer}
					iconName={'shopping-cart'}
					onClick={() => history.push(`${history.location.pathname}/shoppingcart`)}
				/>
			}
			<ButtonEventsOverview
				btnText={context.themeManager.getThemeTextOrHardcodedDefault('goToEventOverviewBtnLabel')}
				buttonContainerStyle={style.buttonContainer}
				iconName="angle-double-left"
			/>
		</div>
	);
}

export default radium(SaleNotPossibleInfo);
